import clsx from "clsx";
import { ButtonIcon } from "./ButtonIcon";
import "./styles.css";

export type ButtonVariant = "primary" | "secondary" | "tertiary" | "card" | "solid";
export type ButtonSize = "sm" | "md" | "lg" | "xl" | "icon";

export interface ButtonProps {
  variant?: ButtonVariant;
  size?: ButtonSize;
  icon?: string;
  iconPosition?: "start" | "end";
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  type?: "button" | "submit" | "reset";
  iconStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  disabled?: boolean;
}

function Button({
  variant = "primary",
  size = "md",
  icon,
  iconPosition = "start",
  onClick,
  className = "",
  type = "button",
  iconStyle,
  style,
  children,
  disabled = false,
}: ButtonProps) {
  const content = (
    <>
      {iconPosition === "start" && <ButtonIcon icon={icon} iconStyle={iconStyle} />}
      {children}
      {iconPosition === "end" && <ButtonIcon icon={icon} iconStyle={iconStyle} />}
    </>
  );

  const classes = clsx(
    "btn",
    `btn--${variant}`,
    size && `btn--${size}`,
    className,
    {
      "is-disabled": disabled,
    }
  );

  const commonProps = {
    className: classes,
    style: style,
  };

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      {...commonProps}
    >
      {content}
    </button>
  );
}

export default Button;
